"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  z900: "#254515",
  z800: "#2F571C",
  z700: "#396822",
  z600: "#437928",
  z500: "#4A842C",
  z400: "#579C34",
  z300: "#6AB445",
  z200: "#95CF76",
  z100: "#C4EFAE",
  z50: "#DBF5CE"
};